import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './route'
import { addRouterRecord } from '../utils/statistic'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes,
  linkActiveClass: 'active'
})

const urlListNeedToken = ['/companyInfo', '/firmSituation', '/figureGarden', '/gardenServe', '/honorAptitude', '/housingInfo', '/investmentInfo', '/situationInfo', '/surroundingFacility', '/surveyInfo', '/compantInfo', '/backstageIndex', '/registrationRecord', '/changePassword', '/logOut']

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// 路由导航守卫
router.beforeEach((to, from, next) => {
  const tokenStr = localStorage.getItem('tokenStr')
  const tokenMoment = sessionStorage.getItem('tokenStr')
  //
  addRouterRecord(to)
  // console.log(to, 'lllllllllllllll')
  //
  // if (tokenStr || tokenMoment) { next() } else {
  //   if (to.path === '/login' ||
  //     to.path === '/register' ||
  //     to.path === '/forgetPassword' ||
  //     to.path === '/page404' ||
  //     to.path === '/userAgreement') {
  //     next()
  //   } else {
  //     router.push({ name: 'login' })
  //   }
  // }
  if (tokenStr || tokenMoment) {
    next()
  } else {
    if (urlListNeedToken.includes(to.path)) {
      router.push({ name: 'login' })
    } else {
      next()
    }
  }

  // 404
  if (to.matched.length === 0) { next('/page404') }
  if (to.path == '/index.html') {
    next('/home')
  }
  // 改变页面titlt
  if (to.meta.title) {
    document.title = '海创帮 | ' + to.meta.title
  } else {
    document.title = '海创帮'
  }
})

// let startTime = Date.now()
// // 定义一个获取用户的函数
// const getUserinfo = (to, from, token) => {
// // 获取当前时间
//   const currentTime = Date.now()
//   const BrowHistory = {
//     preUrl: from.path,
//     preTitle: from.meta.title,
//     currentUrl: to.path,
//     currentTitle: to.meta.title,
//     prePage_browTime: parseInt((currentTime - startTime) / 1000) + 's'
//   }
//   if (token) {
//     BrowHistory.user = JSON.parse(sessionStorage.getItem('user'))
//   }
//   console.log(BrowHistory)
//   console.log(
//     '用户由 ',
//     from.path,
//     ' 页面 跳转到 ',
//     to.path,
//     ' 页面，在 ',
//     from.path,
//     ' 页面停留了 ',
//     currentTime - startTime,
//     '毫秒。转换成秒数约为：',
//     parseInt((currentTime - startTime) / 1000)
//   )
//   // 初始化开始时间
//   startTime = Date.now()
//   console.log('======== 分割线 ========')
// }

// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth === true) {
//     const token = getToken()
//     // 需要登录权限进入的路由
//     if (token) {
//     // 调用刚才定义的函数
//       getUserinfo(to, from, token)
//       next()
//     } else {
//       Message.error('未登录')
//       next({ name: 'login' })
//     }
//   } else {
//     getUserinfo(to, from)
//     // 不需要登录权限
//     next()
//   }
//   // next();
// })

export default router
